import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-learners-analytics',
  templateUrl: './learners-analytics.component.html',
  styleUrl: './learners-analytics.component.scss',
})
export class LearnersAnalyticsComponent implements OnInit {
  iframeUrl = '';

  constructor() {}

  ngOnInit(): void {
    this.iframeUrl = `https://embed.figma.com/proto/2QaOGDiCDNepq7C4EphZab/Analyse_User?node-id=5-7&p=f&scaling=scale-down-width&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=5%3A7&embed-host=share&hide-ui=1`;
  }
}
